/**
 * Has to be a separate file since it's used by the ranking generation tool but also runtime
 */

import {
  type EventClassification,
  type CapabilityTier,
  type CustomerImpact,
  type Actionability,
} from '@canvas/operational-types';
export type RankingDataTuple = [
  EventClassification,
  CustomerImpact,
  CapabilityTier,
  Actionability,
];

export const rankingDataToKey = (eventDataTuple: RankingDataTuple) =>
  eventDataTuple.join('|');
